import api from './api';

export const userService = {
  // Get user profile
  getProfile: async () => {
    const response = await api.get('/user/profile');
    // Backend returns: { success: true, data: { user: {...} } }
    // So we need to return response.data.data which is { user: {...} }
    return response.data?.data || response.data;
  },

  // Update user profile
  updateProfile: async profileData => {
    const response = await api.put('/user/profile', profileData);
    return response.data?.data || response.data;
  },

  // Get user's order history
  getOrderHistory: async (params = {}) => {
    const response = await api.get('/user/orders', { params });
    return response.data?.data || response.data;
  },

  // Get user's favorite products
  getFavorites: async () => {
    const response = await api.get('/user/favorites');
    return response.data?.data || response.data;
  },

  // Add product to favorites
  addFavorite: async productId => {
    const response = await api.post('/user/favorites', { productId });
    return response.data?.data || response.data;
  },

  // Remove product from favorites
  removeFavorite: async productId => {
    const response = await api.delete(`/user/favorites/${productId}`);
    return response.data?.data || response.data;
  },

  // Update password
  updatePassword: async (currentPassword, newPassword) => {
    const response = await api.put('/user/password', {
      currentPassword,
      newPassword,
    });
    return response.data?.data || response.data;
  },
};
